module.exports = __webpack_public_path__ + "static/media/Bird2.7fca67ad.jpg";